import policy from './calendarDisplay.json';

const clock = (minutes) => `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}:00`;
export const CALENDAR_DISPLAY = {
  ...policy,
  slotDuration: clock(policy.slotMinutes),
  snapDuration: clock(policy.snapMinutes),
  collapsedStartTime: clock(policy.collapsedStartHour * 60),
};
